import { freespinsPopupsFont } from '../../fontStyles';
import BasePopup from './BasePopup';
import { gsap } from 'gsap';
import EntryPoint from 'Engine/EntryPoint';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import BaseMoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../../enums/eSounds';
import eEventTypes from '../../enums/eEventTypes';
import animationCreator from 'Engine/animations/animationCreator';
import eAnimationTypes from '../../animations/animationTypes';
import WinAmountAnimated from '../../winAmountAnimated/selfResizedWin';
import { eWinAmountSizes } from '../../enums/eWinAmountSizes';

export default class ControllerFreespinsEnd extends BasePopup {
  constructor(data, displayData) {
    super(data, displayData);
    this.alpha = 0;

    this._valueAnimationDuration = 2000;
    this._idleDuration = 2000;

    this.init();
    this.initAnimation();
  }

  init() {
    super.init();
    this.container = this.wrapper.getChildByName('container');
    this.totalWinLabel = this.container.getChildByName('freespins_popup_end_total_win');
    this.textFieldTotalWin = this.wrapper.getChildByName('amount');
    this.totalWinLabel.correctPosition('center', 'center');
    this.setTextStyle();

    this.winAmountCounter = new WinAmountAnimated(this.textFieldTotalWin, { fontSize: eWinAmountSizes.H.REGULAR });
    this.winAmountCounter.decimals = EntryPoint.GameModel.currencyInfo.decimals;
    this.winAmountCounter.onStop = this.startIdle.bind(this);
  }

  initAnimation() {
    // this.animation = animationCreator.createAnimation(eAnimationTypes.BIG_WIN);
    // this.animation.visible = false;
    // this.wrapper.getChildByName('animationPlace').addChild(this.animation);
  }

  setTextStyle() {
    this.totalWinLabel.style = { ...this.totalWinLabel.style, ...freespinsPopupsFont };
  }

  show(delay) {
    super.show(delay);
    SoundManager.play(eSounds.EST_FS_TOTAL_WIN.soundName, eSounds.EST_FS_TOTAL_WIN.volume, false, eSounds.EST_FS_TOTAL_WIN.group);
    this.playAnimation();
    this.winAmountCounter.animate(0, EntryPoint.GameModel.freespinsTotalWin, this._valueAnimationDuration);
  }

  playAnimation() {
    // this.animation.state.setAnimation(0, eAnimationNames.EAN_FREE_SPINS_END__START, false);
    // this.animation.state.addAnimation(0, eAnimationNames.EAN_FREE_SPINS_END__IDLE, true, 0);
    // this.animation.visible = true;
  }

  stopAnimation() {
    // this.animation.visible = false;
    // this.animation.state.clearTrack(0);
    // this.animation.lastTime = null;
  }

  onShow() {
    super.onShow();
    GlobalDispatcher.dispatch(eEventTypes.EET_FREESPINS_END__SHOWN_UP);
  }

  onHide() {
    super.onHide();
    this.stopAnimation();
    this.winAmountCounter.set(0);
    GlobalDispatcher.dispatch(eEventTypes.EET_FREESPINS_END__ON_COMPLETE)
  }

  stopMainBackgroundSound() {
    const sound = SoundManager.getSound(eSounds.EST_BACKGROUND_BONUS.soundName);
    gsap.to(sound, {
      volume: 0,
      duration: 0.5,
      onComplete: () => SoundManager.pause(eSounds.EST_BACKGROUND_BONUS.soundName)
    });
  }
}
